module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page == 'home') ? _c('div', [_c('div', {
    staticClass: "row col-md-12"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_vm._t("home")], 2), _vm._v(" "), (_vm.dados.anais_cor_bg_menus == null || _vm.dados.anais_cor_bg_menus == '' || !_vm.dados.anais_cor_bg_menus) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', [_c('div', {
    staticClass: "box-1 pull-left"
  }, [_c('div', {
    staticClass: "box-1-child"
  }, [_c('div', {
    staticClass: "box-1-num",
    attrs: {
      "id": "trabalhos_publicados"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.trabalhos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('trabalho_publicado', 2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-1 pull-right"
  }, [_c('div', {
    staticClass: "box-1-child"
  }, [_c('div', {
    staticClass: "box-1-num",
    attrs: {
      "id": "eixos_tematicos"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.eixos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo_tematico', 2))))])])])])]) : _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', [_c('div', {
    staticClass: "box-1-new pull-left",
    style: ({
      background: _vm.dados.anais_cor_bg_stats,
      border: _vm.dados.anais_cor_bg_stats + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_stats
    })
  }, [_c('div', {
    staticClass: "box-1-child-new"
  }, [_c('div', {
    staticClass: "box-1-num-new",
    attrs: {
      "id": "trabalhos_publicados"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.trabalhos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text-new"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('trabalho_publicado', 2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-1-new pull-right",
    style: ({
      background: _vm.dados.anais_cor_bg_stats,
      border: _vm.dados.anais_cor_bg_stats + ' solid 1px',
      color: _vm.dados.anais_cor_fonte_stats
    })
  }, [_c('div', {
    staticClass: "box-1-child-new"
  }, [_c('div', {
    staticClass: "box-1-num-new",
    attrs: {
      "id": "eixos_tematicos"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.eixos.length) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "box-1-text-new"
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo_tematico', 2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    domProps: {
      "innerHTML": _vm._s(_vm.dados.anais_msg_home_stats)
    }
  }, [_vm._v(_vm._s(_vm.dados.anais_msg_home_stats))])])])])]) : (_vm.page == 'corpo_editorial') ? _c('div', {
    staticClass: "col-md-12"
  }, [_vm._t("corpo_editorial")], 2) : (_vm.eixos) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('h1', {
    attrs: {
      "id": "eixos-title"
    }
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.$tc('eixo', 2))))]), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "eixos"
    }
  }, _vm._l((_vm.eixos), function(e) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'trabalhos',
          params: {
            pesquisa: e.nome
          }
        }
      }
    }, [_vm._v("\n        " + _vm._s(e.nome) + " (" + _vm._s(e.trabalhos.length) + ")\n      ")])], 1)
  }))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cdc4f8f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/anais/AnaisMain.vue
// module id = 210
// module chunks = 0